export const insertLocalData = (key, data) => {
  const dataString = JSON.stringify(data);
  localStorage.setItem(key, dataString);
};

export const getLocalData = (key) => {
  const dataString = localStorage.getItem(key);
  if (dataString) {
    return JSON.parse(dataString);
  }
  return null;
};
